// src/transformObject.ts
function transformObject(objectFunctions, source) {
  const _transform = (s) => Object.keys(objectFunctions).reduce((acc, key) => {
    return {
      ...acc,
      [key]: objectFunctions[key](s)
    };
  }, {});
  return arguments.length === 2 && source ? _transform(source) : function(_source) {
    return _transform(_source);
  };
}
var transformObject_default = transformObject;

export {
  transformObject_default
};
//# sourceMappingURL=chunk-FYT4RKPK.mjs.map